import { useEffect, useRef, useState } from 'react';

/**
 * Calls `fn` every `interval` ms. Starts immediately.
 * Returns { paused, toggle, lastUpdated }.
 */
const usePolling = (fn, interval = 15000) => {
  const [paused, setPaused] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    if (paused) return;
    const tick = async () => {
      await fnRef.current();
      setLastUpdated(new Date());
    };
    const id = setInterval(tick, interval);
    return () => clearInterval(id);
  }, [interval, paused]);

  return {
    paused,
    toggle: () => setPaused(p => !p),
    lastUpdated,
  };
};

export default usePolling;
